/**
 * @desc 获取沃尔玛采购单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  shipmentId: string | number,
  params: API.wms.allocationMaster.getByShipmentId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/getByShipmentId/${shipmentId}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
